module.exports = __webpack_public_path__ + "static/media/header.ba1ecaac.jpg";